import { _ as _define_property } from "@swc/helpers/_/_define_property";
export var DiscountExpirationType = /*#__PURE__*/ function(DiscountExpirationType) {
    DiscountExpirationType["Days"] = "days";
    DiscountExpirationType["Date"] = "date";
    return DiscountExpirationType;
}({});
export class LimitedTimeDiscountOfferModel {
    static fromDTO(dto) {
        return new LimitedTimeDiscountOfferModel(dto.expiration);
    }
    Expiration() {
        return this.expiration;
    }
    DiscountExpirationType() {
        return this.expiration.type;
    }
    ExpirationDays() {
        return this.expiration.type === "days" ? this.expiration.days : undefined;
    }
    ExpirationDate() {
        return this.expiration.date || undefined;
    }
    IsWithin() {
        return this.expiration.type === "days";
    }
    IsUntil() {
        return this.expiration.type === "date";
    }
    setExpiration(expiration) {
        return new LimitedTimeDiscountOfferModel(expiration);
    }
    setExpirationDays(days) {
        return new LimitedTimeDiscountOfferModel({
            type: "days",
            days
        });
    }
    setExpirationDate(date) {
        return new LimitedTimeDiscountOfferModel({
            type: "date",
            date
        });
    }
    constructor(expiration){
        _define_property(this, "expiration", void 0);
        this.expiration = expiration;
    }
}
